import { LinkifyMe } from "helpers/efficeHelpers";
import React from "react";

const SpaceChatMsg = ({ name, time, text }) => {
  return (
    <div className="chat-msg-container">
      <div className="headery">
        <span className="namey">{name}</span>
        <span className="timey">{time}</span>
      </div>
      <LinkifyMe>
        <div className="texty">{text}</div>
      </LinkifyMe>
    </div>
  );
};

export default SpaceChatMsg;
